import { HomePage } from "./../home/home";
import { ViewHeaderPage } from "./../view-header/view-header";
import { ServiceProvider } from "./../../providers/service/service";
import { TranslateService } from "@ngx-translate/core";
import { Component } from "@angular/core";
import {
  IonicPage,
  NavController,
  NavParams,
  LoadingController,
} from "ionic-angular";
import { SelectSearchableComponent } from "ionic-select-searchable";
import { Storage } from "@ionic/storage";
import { Http, RequestOptions, Headers } from "@angular/http";

class Discount {
  public discount_id: number;
  public name: string;
}

@IonicPage()
@Component({
  selector: "page-plaza-collect-fee-confirm",
  templateUrl: "plaza-collect-fee-confirm.html",
})
export class PlazaCollectFeeConfirmPage {
  code: string = "";
  discounts: Discount[];
  discount: Discount;
  space: any;
  plaza_id = "";
  plaza_name = "";
  theme = 1;
  discountVal: number | null = null;
  shopVal: number | null = null;

  public qrData = null;
  public qrDetail = null;
  public createdCode: string = null;

  constructor(
    public navCtrl: NavController,
    public navParams: NavParams,
    private storage: Storage,
    private http: Http,
    private translateService: TranslateService,
    private services: ServiceProvider,
    private loadingCtrl: LoadingController
  ) {
    this.space = this.navParams.data.space;
  }

  async ionViewDidLoad() {
    console.log("จ่ายค่าเช่า 1");
    this.theme = await this.storage.get("theme");

    const loader = this.loadingCtrl.create({
      content: "Loading...",
    });
    loader.present();

    this.storage.get("info").then((info) => {
      this.plaza_id = info.team.plaza_id;
      this.plaza_name = info.team.plaza_name;

      this.qrData = {
        plaza_id: this.plaza_id,
        plaza_name: this.plaza_name,
        space_no: this.space.space_no,
        shop_id: this.space.shop.shop_id,
        shop_name: this.space.shop.shop_name,
        discount: "0",
        action: "collect",
      };
      this.createdCode = JSON.stringify(this.qrData);
    });

    this.space.cost = this.space.shop.rental_fee;

    this.storage.get("token").then((token) => {
      var link2 = this.services.URLDiscount;
      var headers = new Headers();
      headers.append("Accept", "application/json");
      headers.append("Authorization", "Bearer " + token);
      const requestOptions = new RequestOptions({ headers: headers });

      this.http
        .get(link2, requestOptions)
        .map((res) => res.json())
        .subscribe(
          (data) => {
            this.discounts = data;
            loader.dismiss();
          },
          (error) => {
            var response = JSON.parse(error._body);
            this.translateService.get(response.message).subscribe((value) => {
              this.services.presentToast(value);
            });
            loader.dismiss();
          }
        );
    });
  }

  /** getCode for new function ##จ่ายค่าเช่า 1 */
  getCode() {
    const loader = this.loadingCtrl.create({
      content: "Loading...",
    });

    loader.present();

    this.storage.get("token").then((token) => {
      var link = this.services.URLPlazaRentSpaceCode;
      var headers = new Headers();
      headers.append("Accept", "application/json");
      headers.append("Authorization", "Bearer " + token);
      const requestOptions = new RequestOptions({ headers: headers });

      this.http
        .post(
          link,
          {
            space_id: this.space.space_no,
            shop_id: this.space.shop.shop_id,
            discount: this.discount.discount_id,
            merchant_id: this.space.merchant.merchant_id,
          },
          requestOptions
        )
        .map((res) => res.json())
        .subscribe(
          (data) => {
            // console.log(data);
            this.code = data.code;
            loader.dismiss();
          },
          (error) => {
            var response = JSON.parse(error._body);
            this.translateService.get(response.message).subscribe((value) => {
              this.services.presentToast(value);
            });
            loader.dismiss();
          }
        );
    });
  }

  discountChange(event: { component: SelectSearchableComponent; value: any }) {
    let discount = event.value.discount_id;
    this.space.cost =
      parseFloat(this.space.shop.rental_fee) +
      parseFloat(this.space.shop.rental_fee) * (parseFloat(discount) / 100);

    this.qrData = {
      plaza_id: this.plaza_id,
      plaza_name: this.plaza_name,
      space_no: this.space.space_no,
      shop_id: this.space.shop.shop_id,
      shop_name: this.space.shop.shop_name,
      discount: discount,
      action: "collect",
    };
    this.createdCode = JSON.stringify(this.qrData);
  }

  copyToClipboard = (): boolean => {
    const el = document.createElement("textarea");
    el.value = this.code;
    el.setAttribute("readonly", "");
    // el.style = { position: "absolute", left: "-9999px" };
    document.body.appendChild(el);

    el.select();
    // Copy text to clipboard
    try {
      const successful = document.execCommand("copy");
      if (successful) {
        document.body.removeChild(el);
        // copy to clipboard
        this.services.presentToast("copied!");
        return true;
      }
    } catch (err) {
      return false;
    }

    return false;
  };

  backPage() {
    this.navCtrl.pop();
  }

  openHeadPage() {
    this.navCtrl.push(ViewHeaderPage);
  }

  homePage() {
    this.navCtrl.setRoot(HomePage);
  }
}



// WEBPACK FOOTER //
// ./src/pages/plaza-collect-fee-confirm/plaza-collect-fee-confirm.ts